import { useContext, useEffect } from 'react';
import {
  AssessmentsNativeBridgeContext,
  CloseRequestedHandler,
} from '../contexts/AssessmentsNativeBridgeContext';

// Registers what to do when native asks the assessment to save and close. While no assessment is
// mounted (or outside the native bridge) there is no handler and the request is ignored.
export const useAssessmentsCloseRequested = (handler: CloseRequestedHandler) => {
  const handlerRef = useContext(AssessmentsNativeBridgeContext);

  useEffect(() => {
    if (!handlerRef) {
      return undefined;
    }

    handlerRef.current = handler;

    return () => {
      handlerRef.current = null;
    };
  }, [handlerRef, handler]);
};
